import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import LanguageModel from '@/views/Language/models/language'
import UnsavedTranslationDialog from '../dialogs/unsavedTranslation/unsavedTranslation.vue'
export default class TranslationModel extends JsonApiObject {
    static limit = 20

    static async get(transaltionId: string) {
        let query = {
            include: ['string', 'language', 'textHistory'],
        }

        let res = await Vue.prototype.$vbit.get('language', `translations/${transaltionId}`, query)

        return res.data ? new TranslationModel(res.data, res.included) : res
    }

    static async search(filters: any) {
        let query = {
            include: [
                'string.translations.language',
                'string.translations.textHistory',
                'string.attachments',
                'string.tokens',
                'string.group',
            ],
            filters,
        }

        let res = await Vue.prototype.$vbit.get('language', `translations`, query)

        if (res) {
            let transaltions = res.data.map((transaltion) => {
                let trans = new TranslationModel(
                    transaltion,
                    res.included.filter(
                        (item) => item._type == 'language' || item._type == 'textHistory'
                    )
                )
                trans._relationships.string = null
                return trans
            })

            let strings = res.included.filter((item) => item._type == 'string')

            strings.map((string) => string.initalize(string, [...res.included, ...transaltions]))

            return { strings: strings, length: transaltions.length }
        } else {
            return null
        }
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    status
    text
    createdAt
    updatedAt

    get string() {
        return this._relationships['string'] ? this._relationships['string'] : null
    }

    get language(): LanguageModel {
        return this._relationships['language'] ? this._relationships['language'] : null
    }

    set language(language: LanguageModel) {
        this._relationships['language'] = language
    }

    get hasTextHistory() {
        return this._relationships['textHistory'] && this._relationships['textHistory'].length > 0
    }

    get textHistory() {
        return this._relationships['textHistory'] ? this._relationships['textHistory'] : []
    }

    async initUnsavedTranslation(translation: TranslationModel, text: string, string) {
        return await JsonApiObject.openDialog(UnsavedTranslationDialog, {
            translation,
            text: text,
            string,
        })
    }

    async patchText(text: string | null, token: string | null = null) {
        let attributes = {
            text: text,
            status: this.status == 'untranslated' ? 'unverified' : this.status,
        }

        return this.patch(attributes, token)
    }

    async patchStatus(status: string, token: string | null = null) {
        let attributes = {
            status: status,
        }

        return this.patch(attributes, token)
    }

    async patch(attributes: any, token: string | null = null) {
        let query = {
            ...(token && {
                token,
            }),
            include: ['string', 'language', 'textHistory'],
            body: {
                data: {
                    type: this._type,
                    id: this._id,
                    attributes: attributes,
                },
            },
            updatedAt: this['updatedAt'],
        }

        let res = await Vue.prototype.$vbit.patch('language', `translations/${this._id}`, query)

        return res.data ? this.initalize(res.data, res.included) : res
    }
}
